import { useEffect, type FC } from "react";
import { LeapChatContentPositioner } from "./leapChat.styles";
import styled from "@emotion/styled";
import { useBlocNext } from "@blac/react";
import LeapChatCubit from "./LeapChatCubit";

const Title = styled.div`
  padding: 2rem;
  font-family: "STK Bureau Serif Light", serif;
  font-size: 1.2rem;
  font-weight: 300;
  line-height: 1.1;
  letter-spacing: -0.6px;
  color: var(--color-charcoal, #212121);
`;

const EmptyStateText = styled.p`
  padding: 0 2rem;
  font-size: 1rem;
  line-height: 1.4;
  letter-spacing: -0.32px;
  color: var(--color-charcoal-60, rgba(33, 33, 33, 0.6));
  margin: 0;
`;

const UpdatesView: FC = () => {
  const [, cubit] = useBlocNext(LeapChatCubit);

  useEffect(() => {
    cubit.clearActiveConversation();
  }, [cubit]);

  return (
    <LeapChatContentPositioner>
      <Title>Updates</Title>
      <EmptyStateText>
        No updates yet — we'll share news about your care here.
      </EmptyStateText>
    </LeapChatContentPositioner>
  );
};

export default UpdatesView;
